module.exports = __webpack_public_path__ + "media/images/employees/job-4cbc98dcd449b107b08a693f09002198.png";